import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, Download } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { waiverPdfUrl } from "../WaiverForm";

function Waivers() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/waivers").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  async function sendAll() {
    if (!window.confirm(`Email the Photo & Media Release to ${d.total_users - d.signed_users} users who haven't signed?`)) return;
    try { const { data } = await api.post("/admin/waivers/send-all"); toast.success(`Sent to ${data.sent} users. They'll also be asked at their next login.`); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  }
  if (!d) return null;
  return (
    <div className="space-y-3" data-testid="admin-waivers">
      <div className="flex flex-wrap items-center gap-3">
        <p className="font-serif text-2xl mr-auto">Photo & Media Release</p>
        <span className="text-sm" data-testid="admin-waivers-count">{d.signed_users} / {d.total_users} users signed · {d.guest_waivers} guest signatures</span>
        <button onClick={sendAll} className="btn-gold !py-2 text-xs" data-testid="admin-waivers-send-all"><Send className="w-3.5 h-3.5" /> Send to everyone who hasn't signed</button>
      </div>
      <div className="bg-white border border-[var(--line)] rounded-2xl divide-y divide-[var(--line)] max-h-72 overflow-y-auto">
        {d.recent.map((w) => (
          <div key={w.waiver_id} className="flex items-center gap-3 px-4 py-2 text-sm">
            <span className="mr-auto"><b>{w.full_name}</b> <span className="text-xs text-[var(--muted)]">{w.kind === "guest" ? `guest · ${w.wedding_slug}` : w.email} · {new Date(w.signed_at).toLocaleDateString()}</span></span>
            <a href={waiverPdfUrl(w)} className="text-[var(--gold)]" title="PDF" data-testid={`admin-waiver-pdf-${w.waiver_id}`}><Download className="w-4 h-4" /></a>
          </div>
        ))}
        {!d.recent.length && <p className="px-4 py-3 text-sm text-[var(--muted)]">No signatures yet.</p>}
      </div>
    </div>
  );
}

function Podcast() {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ email: "", name: "", topic: "" });
  const load = () => api.get("/admin/podcast/interviews").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const act = (id, a) => api.post(`/admin/podcast/interviews/${id}/${a}`).then(() => { toast.success(a === "approve" ? "Guest release sent" : "Declined"); load(); }).catch((e) => toast.error(formatApiError(e)));
  async function invite(e) {
    e.preventDefault();
    try { await api.post("/admin/podcast/invite", f); toast.success("Invite + release sent"); setF({ email: "", name: "", topic: "" }); load(); } catch (err) { toast.error(formatApiError(err)); }
  }
  return (
    <div className="space-y-3" data-testid="admin-podcast-interviews">
      <p className="font-serif text-2xl">Podcast interviews</p>
      <form onSubmit={invite} className="grid md:grid-cols-4 gap-2">
        <input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Name" className="input-luxe" data-testid="podcast-invite-name" />
        <input required type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="Email" className="input-luxe" data-testid="podcast-invite-email" />
        <input value={f.topic} onChange={(e) => setF({ ...f, topic: e.target.value })} placeholder="Topic (optional)" className="input-luxe" data-testid="podcast-invite-topic" />
        <button className="btn-gold" data-testid="podcast-invite-send">Invite & send release</button>
      </form>
      {rows.map((r) => (
        <div key={r.request_id} className="bg-white border border-[var(--line)] rounded-2xl p-4 flex flex-wrap items-center gap-3 text-sm" data-testid={`podcast-row-${r.request_id}`}>
          <div className="mr-auto"><b>{r.name}</b> <span className="text-xs text-[var(--muted)]">{r.email} · {r.role} · {r.source}</span><p className="text-xs">{r.topic}{r.availability && ` · ${r.availability}`}</p></div>
          <span className="text-xs uppercase tracking-wider" data-testid={`podcast-status-${r.request_id}`}>{r.status}</span>
          {r.status === "requested" && <><button onClick={() => act(r.request_id, "approve")} className="btn-gold !py-1.5 text-xs" data-testid={`podcast-approve-${r.request_id}`}>Approve & send release</button><button onClick={() => act(r.request_id, "decline")} className="text-xs underline" data-testid={`podcast-decline-${r.request_id}`}>Decline</button></>}
        </div>
      ))}
    </div>
  );
}

export function WaiverPodcastAdmin() {
  return <div className="space-y-10"><Waivers /><Podcast /></div>;
}
